import { notificate } from "@/utils/message";
import moment from "moment";

export const transformDataToUpdate = (edit, original, minValidFrom) => {
    let edited = Object.assign({}, edit);
    const dateIsValidate = moment(minValidFrom).isAfter(edit.valid_until);
    if (dateIsValidate) {
        notificate(
            `La fecha de ingreso debe ser anterior a la fecha de término`,
            "is-danger is-light"
        );
        return false;
    } else {
        edited.valid_from = moment(edited.valid_from).format("YYYY-MM-DD");
        edited.valid_until = moment(edited.valid_until).format("YYYY-MM-DD");
        edited.amount = Number(
            edited.amount.replace("$ ", "").replace(/\./g, "")
        );
        edited.indefinite_term = !!Number(edited.indefinite_term);
        if (
            edited.valid_until === original.valid_until ||
            (edited.indefinite_term && !edited.is_terminated)
        ) {
            delete edited.valid_until;
        }
        if (edited.indefinite_term === original.indefinite_term) {
            delete edited.indefinite_term;
        }
        if (edited.valid_from === original.valid_from) {
            delete edited.valid_from;
        }
        if (edited.amount === original.amount) {
            delete edited.amount;
        }
        if (edited.is_terminated === original.is_terminated) {
            delete edited.is_terminated;
        }
        return Object.assign({}, edited);
    }
};

export const getMinValidFrom = (valid_from = new Date()) => {
    const today = moment()
        .subtract(1, "days")
        .toDate();
    if (moment(valid_from).isAfter(today)) return moment(valid_from).toDate();
    else return today;
};
